/* eslint-disable ember/template-no-bare-strings */
/* istanbul ignore file */
import Component from "@glimmer/component";
import { on } from "@ember/modifier";
import { fn } from "@ember/helper";
import { getOwnConfig, importSync, macroCondition } from "@embroider/macros";

let LoginDevPanel;

if (macroCondition(getOwnConfig().devtools)) {
  const DevPanel = importSync("glesys-controlpanel/components/dev-tools/panel").default;

  class DevPanelImpl extends Component {
    toggle = (property) => {
      this.args.context[property] = !this.args.context[property];
    };

    <template>
      <DevPanel @title="Login">
        <button
          class="cursor-pointer rounded border border-gray-200 bg-gray-50 px-1 py-0.5 text-left dark:border-transparent dark:bg-white/10"
          type="button"
          {{on "click" (fn this.toggle "displayOneTimePassword")}}
        >
          Toggle OTP field
        </button>
        <button
          class="cursor-pointer rounded border border-gray-200 bg-gray-50 px-1 py-0.5 text-left dark:border-transparent dark:bg-white/10"
          type="button"
          {{on "click" (fn this.toggle "displayVerificationCode")}}
        >
          Toggle verification code
        </button>
      </DevPanel>
    </template>
  }

  LoginDevPanel = DevPanelImpl;
} else {
  LoginDevPanel = <template></template>;
}

export default LoginDevPanel;
